import type { YellowpaperRegistry } from '@toolproof-core/genesis/_contract/generation';
import { validateScopedTree } from '@toolproof-core/validation/_pure/scoped-tree-validation';
import { yellowpaperSchemaOptions } from '@toolproof-core/validation/_data/schema-options';
import type { ScopedTreeIssue, ScopedTreeValidationResult } from '@toolproof-core/validation/_contract/scoped-tree-validation';

export function validateCoreYellowpapers(tree: unknown, registry: YellowpaperRegistry): ScopedTreeValidationResult {
    const issues: ScopedTreeIssue[] = [];
    if (!registry['.']) {
        issues.push({
            kind: 'schema', filePath: '.yellowpaper.json', scope: '.', repositoryPath: '.',
            schemaPath: '', keyword: 'required', message: 'The root yellowpaper is required.',
        });
    }
    for (const entry of Object.values(registry)) {
        if (entry.document.$schema !== 'https://toolproof.dev/schemas/yellowpaper/dialect'
            || typeof entry.document.$id !== 'string' || entry.document.$id.length === 0) {
            issues.push({
                kind: 'schema', filePath: entry.filePath, scope: entry.scope, repositoryPath: entry.scope,
                schemaPath: '', keyword: 'identity',
                message: 'Yellowpapers require the ToolProof yellowpaper dialect and a nonempty $id.',
            });
        }
    }
    const result = validateScopedTree({
        tree,
        schemas: Object.values(registry).map(entry => ({
            filePath: entry.filePath,
            scope: entry.scope,
            schema: entry.document,
        })),
        registryOptions: yellowpaperSchemaOptions,
    });
    return { valid: issues.length === 0 && result.valid, issues: [...issues, ...result.issues] };
}

export function assertCoreYellowpapers(tree: unknown, registry: YellowpaperRegistry): void {
    const result = validateCoreYellowpapers(tree, registry);
    if (!result.valid) {
        throw new Error(`Invalid Core yellowpapers or repository tree:\n${result.issues.map(issue =>
            `${issue.repositoryPath}: ${issue.message} (${issue.filePath}; ${issue.schemaPath || '#'})`,
        ).join('\n')}`);
    }
}
